import React from "react";
import { useField } from "formik";
import { ErrorMessage } from "@jsq/ds/core";
import { COUNTRY_MISMATCH_MESSAGE } from "../../common/constants";
import { validateBankCountryMatch } from "../../common/utils";

export type BankCountryMismatchWarningProps = {
  bankCountryName: string | undefined;
  validatedCountryField: string;
};

export const BankCountryMismatchWarning: React.FC<BankCountryMismatchWarningProps> = ({
  bankCountryName,
  validatedCountryField,
}) => {
  const [{ value: validatedCountry }] = useField<string | undefined>(validatedCountryField);
  if (validateBankCountryMatch(bankCountryName, validatedCountry)) {
    return null;
  }
  return <ErrorMessage>{COUNTRY_MISMATCH_MESSAGE}</ErrorMessage>;
};
